import { putApiGalaxyServer } from 'services';

export interface SetTeamAiBlockedPayload {
  teamId: number;
  aiBlocked: boolean;
}

export interface SetTeamAiBlockedResponse {
  teamId: string;
  aiBlocked: boolean;
  /** The block's turn-off (absent on unblock): which copies took it right away. */
  disabled?: { searchTeamUpdated: boolean; aiServerUpdated?: boolean };
}

/**
 * Block or unblock a team's AI suggestions through galaxy-server (admin only).
 * Blocking also turns the team's AI suggestions off; unblocking leaves them
 * off. The route is tenant/realm scoped, so callers pass the team's headers
 * in `config`.
 */
export const setTeamAiBlockedApi = ({
  params: { teamId, aiBlocked },
  token,
  config,
}: BaseApiParams<SetTeamAiBlockedPayload>) =>
  putApiGalaxyServer<Omit<SetTeamAiBlockedPayload, 'teamId'>, SetTeamAiBlockedResponse>(
    `/ai_api/teams/${teamId}/ai-blocked`,
    { aiBlocked },
    config ?? {},
    token,
  );
